// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f5a2a58b","683":"6d2c144c"}[chunkId] + ".chunk.js";
};